import { render, staticRenderFns } from "./ReportSectionPdrValuation.vue?vue&type=template&id=6b02e074&scoped=true&lang=html&"
import script from "./ReportSectionPdrValuation.vue?vue&type=script&lang=js&"
export * from "./ReportSectionPdrValuation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b02e074",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VFlex,VLayout})
